<div class="input-grid-gaps grid-1col">
    <app-button styleClass="w-full" [label]="'voucher.export.printVoucher'" size="large"
        (clickEvent)="printVoucher()"></app-button>
    <app-button styleClass="w-full" [label]="'voucher.export.printDailyRecords'" size="large"
        (clickEvent)="printDailyRecords()"></app-button>
    <app-button styleClass="w-full" [label]="'voucher.export.printNursingCarePlan'" size="large"
        (clickEvent)="printNursingCare()"></app-button>
    <app-button styleClass="w-full" [label]="'voucher.export.printAssessment'" size="large"
        (clickEvent)="printAssessment()"></app-button>
</div>
<div #dialogFooter class="p-dialog-footer"></div>
